import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-370">
      <div className="container mx-auto px-4" data-id="element-371">
        <FadeIn data-id="element-372">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-373">
            <div className="flex flex-col items-center text-center px-4" data-id="element-374">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-375">
                🏭
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-376">
                +200
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-377">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-378">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-379">
                📚
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-380">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-381">
                Tomos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-382">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-383">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-384">
                3
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-385">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-386">
              <div className="flex gap-1 mb-3" data-id="element-387">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-lg" data-id="element-388">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-389">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-390">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-391">
          <FadeIn delay={0.1} data-id="element-392">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-393">
              <div className="flex gap-1 mb-4" data-id="element-394">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-395">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-396">
                "Antes presupuestaba a ojo y siempre terminaba ganando menos de
                lo que pensaba. Con el sistema de costos del Tomo 1 ahora sé
                exactamente cuánto gano en cada trabajo."
              </p>
              <div className="flex items-center gap-3" data-id="element-397">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-398">
                  A
                </div>
                <div data-id="element-399">
                  <p className="font-bold text-white text-sm" data-id="element-400">Adrián L.</p>
                  <p className="text-xs text-gray-500" data-id="element-401">
                    Gran Buenos Aires · Taller de Herrería
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-402">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-403">
              <div className="flex gap-1 mb-4" data-id="element-404">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-405">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-406">
                "El Tomo 4 me salvó en plena suba de precios. La cláusula
                gatillo me permitió no perder plata en trabajos que ya había
                presupuestado."
              </p>
              <div className="flex items-center gap-3" data-id="element-407">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-408">
                  G
                </div>
                <div data-id="element-409">
                  <p className="font-bold text-white text-sm" data-id="element-410">Gustavo R.</p>
                  <p className="text-xs text-gray-500" data-id="element-411">
                    Santa Fe · Herrero Independiente
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-412">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-413">
              <div className="flex gap-1 mb-4" data-id="element-414">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-415">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-416">
                "Nunca pensé que iba a poder calcular el peso de los perfiles
                tan rápido. Las tablas del Tomo 3 las tengo pegadas en el taller
                y las uso todos los días."
              </p>
              <div className="flex items-center gap-3" data-id="element-417">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-418">
                  N
                </div>
                <div data-id="element-419">
                  <p className="font-bold text-white text-sm" data-id="element-420">Néstor V.</p>
                  <p className="text-xs text-gray-500" data-id="element-421">
                    Tucumán · Herrería y Rejas
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}